<template>
  <div>
    <div class="text-center depahead rsu">ยืนยันตัวตน</div>
    <div
      style="
        max-width: 500px;
        margin-left: auto;
        margin-right: auto;
        position: relative;
      "
    >
      <div class="text-right" style="position: absolute; right: 0px; top: -14px">
        <v-btn :loading="logoutloading" @click="logout" color="primary" text class="pl-0">
          ออกจากระบบ
        </v-btn>
      </div>
      <div style="height: 60px; padding-top: 10px">
        <v-img style="margin-left: auto; margin-right: auto" width="80px" src="../../assets/depa.png"></v-img>
      </div>
      <v-container>
        <div class="mb-6" style="font-weight: 600; font-size: 22px">
          ยืนยันตัวตน
        </div>
        <div>
          <div style="color: grey">เลือกประเภท</div>
          <ValidationObserver ref="observer">
            <ValidationProvider name="ประเภท" :key="'ประเภท'" :rules="{ required: true }" v-slot="{ errors }">
              <v-select item-text="type" return-object :items="$store.state.membertype" placeholder="ประเภทสมาชิก" :error-messages="errors" v-model="input.membertype" outlined dense style="border-radius: 6px"></v-select>
            </ValidationProvider>
          </ValidationObserver>
        </div>
        <div class="submitbtn">
          <v-btn depressed @click="next" color="primary" class="text-capitalize" block>Next</v-btn>
        </div>
      </v-container>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      logoutloading: false,
      input: {
        membertype: "",
      },
    };
  },
  async mounted() {
    await this.getMemberType();
  },
  methods: {
    async logout() {
      this.$swal
        .fire({
          text: "ต้องการออกจากระบบ ?",
          showCancelButton: true,
          confirmButtonText: "ยืนยัน",
          cancelButtonText: "ยกเลิก",
          confirmButtonColor: "#152d53",
          cancelButtonColor: "grey",
        })
        .then(async (result) => {
          if (result.value) {
            this.logoutloading = true;
            axios
              .post(
                this.serverUrl + "depalogout",
                { userid: this.userid, memberid: this.$store.state.memberid },
                {
                  headers: {
                    AUTHORIZATION: "Bearer xxx xxx",
                  },
                }
              )
              .then(async (response) => {
                this.logoutloading = false;
                if (response.data.responsecode == 200) {
                  await this.$store.dispatch("sendMessage", "ออกจากระบบแล้ว");
                  if (response.data.responsecode != 300) {
                    await this.$liff.closeWindow();
                  }
                } else {
                  this.$swal.fire({
                    texxt: response.data.reason,
                  });
                }
              });
          }
        });
    },
    async getMemberType() {
      return new Promise((resolve) => {
        axios
          .get(this.serverUrl + "depamembertypeall", {
            headers: {
              AUTHORIZATION: "Bearer xxx xxx",
            },
            params: {
              pageid: this.query.pageid,
              active: "true",
            },
          })
          .then((response) => {
            if (response.data.responsecode == 200) {
              this.$store.state.membertype = response.data.data;
            } else {
              this.$swal.fire({
                text: response.data.reason,
              });
            }
          });
      });
    },
    async next() {
      if (await this.$refs.observer.validate()) {
        // var membertype = this.input.type.type;
        var verification = this.input.membertype.verification;
        this.$store.dispatch("setinput", {
          ...this.input.membertype,
          membertype: this.input.membertype.type,
          membertype_id: this.input.membertype.typeid,
        });

        if (verification == "บุคคลธรรมดา" || verification == "เกษตรกร") {
          this.query.view = "VerifyRegular";
        } else if (verification == "มี Tax ID") {
          this.query.view = "VerifyTaxID";
        } else {
          this.query.view = "VerifyNoTaxID";
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
